var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('title-card',{attrs:{"title":"Upload Files For This Loan"}},[(_vm.checkPermissionForStandardDocument)?_c('upload-multiple-files',{attrs:{"url-upload":_vm.loansDocsUrl,"show-input":true,"auto-send":false,"params":_vm.uploadParams},on:{"success":_vm.onSuccessUpload}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34351bee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/my_deals/deals/documents/UploadFiles.vue
// module id = null
// module chunks = 